/**
 * Liens de téléchargement des factures d'un cours ponctuel dans la fiche et l'historique du prof.
 *
 * Verified Trainer, deux circuits selon la date de déclaration du cours (bascule du 1er novembre 2026) :
 * - nouveau circuit : le coach voit sa facture (adressée à Verified Trainer) et la facture de Verified Trainer SAP
 *   au client (fichier VT-SAP-{idCours}-{NNNNNN}) ; la sous-traitance (VT-ST-) ne le concerne pas ;
 * - ancien circuit : le coach voit sa facture et la facture des frais de gestion (fichier R-{idProf}-{idCours}-…),
 *   comme dans l'e-mail de l'époque ; le récapitulatif global (invoiceRecap) n'est pas proposé.
 * Teach'r et Déclarons : seule la facture du prof.
 *
 * Les listes de l'API n'exposent ni la date de déclaration ni le circuit : il se lit sur le nom du fichier client.
 */
export type PunctualInvoiceLinks = {
  coach: string | null;
  client: string | null;
  fees: string | null;
};

const VT_SAP_CLIENT_INVOICE_PREFIX = "VT-SAP-";
const SUBCONTRACTING_MARKERS = ["SOUS-TRAITANCE", "VT-ST-"];

/** Facture de Verified Trainer SAP au client : signe du nouveau circuit. */
export const isVerifiedTrainerSapInvoice = (url: unknown): boolean =>
  String(url ?? "").includes(VT_SAP_CLIENT_INVOICE_PREFIX);

/** Facture de sous-traitance (ancien ou nouveau circuit), jamais proposée au coach. */
export const isSubcontractingInvoice = (url: unknown): boolean => {
  const value = String(url ?? "");
  return SUBCONTRACTING_MARKERS.some((marker) => value.includes(marker));
};

export const punctualInvoiceLinks = (punctual: any, isVerifiedTrainer: boolean): PunctualInvoiceLinks => {
  const coach: string | null = punctual?.invoice || null;
  if (!isVerifiedTrainer) {
    return { coach, client: null, fees: null };
  }

  const recap: string | null = punctual?.invoiceRecap || null;
  const relation: string | null = punctual?.invoiceRelation || null;
  const newCircuit = isVerifiedTrainerSapInvoice(recap);

  return {
    coach,
    client: newCircuit ? recap : null,
    fees: !newCircuit && relation && !isSubcontractingInvoice(relation) ? relation : null,
  };
};
